import { useRouter } from "next/router";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "../../public/styles/style.css";
// Components
import {
  dateFilterParams,
  dateFormatter,
  frameworkComponents,
  gridOption,
} from "../../constants/ag-grid.constants";
import { APIs } from "../../constants/api.constants";
import { ApiService, getRequest } from "../../services/ApiService";
import DeleteAssessment from "./view/delete-assessment";
import { notification, Spin } from "antd";

const AssessmentsPage = () => {
  const router = useRouter();
  const [assessments, setAssessments] = useState([]);
  const [checkBox1, setCheckBox1] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [assessmentData,setAssessmentData] = useState({})
  const [loading, setLoading] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);

  const columns = [
    {
      headerName: "Assessment Title",
      field: "title",
      minWidth: 250,
      className: "pl-4",
    },
    { headerName: "Description", field: "description", minWidth: 300 },
    {
      headerName: "Episode Title",
      field: "episode_name",
      minWidth: 300,
      valueGetter: function (field) {
        return field.data?.episode?.episode_name;
      },
    },
    {
      headerName: "Updated At",
      field: "updateDate",
      valueGetter: dateFormatter,
      minWidth: 200,
      editable: false,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
    },
    {
      headerName: "View Result",
      field: "result",
      minWidth: 120,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "View",
        buttonClass: "primary",
        clicked: function (field) {
          router.push(`/assessments/view/${field.id}`);
        },
      },
    },
    {
      headerName: "Deleted",
      field: "Deleted",
      editable: false,
      cellRenderer: "btnCellRenderer",
      sortIndex: 0,
      cellRendererParams: {
        buttonText: "Delete",
        buttonClass: "primary",
        clicked: function (field) {
          setAssessmentData(field);
          setDeleteId(field.id);
          toggleDeletePopup();
        },
      },
      minWidth: 130,
    },
  ];

  useEffect(() => {
    getAssessment()
  }, []);

  function resetDeleteInput() {
    setAssessmentData({});
    setDeleteId(null);
    setCheckBox1(false);
    setCheckBox2(false);
  }

  function toggleDeletePopup() {
      deleteVisible && resetDeleteInput();
      setDeleteVisible(!deleteVisible)
  }

  function hardDelete() {
    if (checkBox1 !== true || checkBox2 !== true) {
      return notification["error"]({
        message: "please check all the the checkbox",
      });
    }
    setLoading(true)
    setLoadingRows(true)
    ApiService.deleteRequest(
      APIs.assessment + "/hard-delete/" + deleteId
    ).then(() => {
      toggleDeletePopup();
      getAssessment();
      setLoading(false)
      setLoadingRows(false)
    }),
    (error) => {
      notification["error"]({ message: error.message });
      toggleDeletePopup();
      setLoading(false)
      setLoadingRows(false)
    };
  }

  function getAssessment() {
    setLoadingRows(true);
    getRequest(APIs.assessment).then(
      (res) => {
        setAssessments(res.data);
        setLoadingRows(false);
      },
      (error) => {
        notification["error"]({ message: error.message });
        setLoadingRows(false);
      }
    );
  }

  const deleteAssessmentProps = {
    deleteVisible,
    toggleDeletePopup,
    checkBox1,
    setCheckBox1,
    checkBox2,
    setCheckBox2,
    assessmentData,
    hardDelete,
    loading
  };

  return (
    <>
      <DeleteAssessment props={deleteAssessmentProps} />
      <Spin tip="Loading...." size="small" spinning={loadingRows}>
        <div className="example-wrapper h-minus-180">
          <div className="ag-theme-alpine w-100percent h-100percent">
            <AgGridReact
              rowData={assessments}
              columnDefs={columns}
              defaultColDef={gridOption}
              enableCellTextSelection={true}
              animateRows={true}
              frameworkComponents={frameworkComponents}
              className={"w-100 assessment-table"}
            ></AgGridReact>
          </div>
        </div>
      </Spin>
    </>
  );
};

export default AssessmentsPage;
